import { Moon, Sun } from 'lucide-react'

import { isDarkMode, useThemeStore } from '@/stores/themeStore'
import { cn } from '@/utils/cn'

export function ThemeToggle({ className }: { className?: string }) {
  const mode = useThemeStore((state) => state.mode)
  const toggle = useThemeStore((state) => state.toggle)
  const dark = isDarkMode(mode)

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? 'Ativar tema claro' : 'Ativar tema escuro'}
      title={dark ? 'Tema claro' : 'Tema escuro'}
      className={cn(
        'grid size-9 place-items-center rounded-lg text-fg-muted transition-colors hover:bg-surface-2 hover:text-fg',
        className,
      )}
    >
      {dark ? <Sun className="size-[1.15rem]" /> : <Moon className="size-[1.15rem]" />}
    </button>
  )
}
